export const SVELTE_NODEJS_IMPORT_YAML = `project:
  name: recipe-svelte
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: nodejs@20
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-svelte-nodejs`;
